<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn" @click="initTaskData()"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">我的任务&gt;</div>
      </div>
      <div class="body_content">
        <table class="table task_tab">
          <tbody>
          <tr v-for="(task, index) in tasksList" :key="index">
            <td style="width: 0%;"><div class="noRead_tip" :class="{tip_need: task.status == 0}"></div></td>
            <td class="tabTd_content_ellipsis tabTd_name" :title="task.className">{{task.className}}</td>
            <td class="tabTd_content_ellipsis tabTd_status font_red" :title="task.content">{{task.content}}</td>
            <td class="tabTd_content_ellipsis tabTd_time" :title="task.createTime">{{task.createTime}}</td>
            <td class="tabTd_btn">
              <button type="button" class="btn btn-default btn_option" @click="clazzId=task.classId;publishStatus=task.checkStatus;classStatus=task.stuStatus;saveDataIntoStorage()">去查看</button>
              <button type="button" class="btn btn-default btn_option" v-if="task.status == 0" @click="ignoreTask(task.id)">忽略</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";

  import {getContentSize} from './mainView';

  export default {
    name: "task",
    data() {
      return {
        clazzId : '',
        publishStatus : 0,
        classStatus : 0,
        //任务集合
        tasksList: [],
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.initTaskData();
      });
    },
    methods: {
      /**
       * 加载初始数据
       */
      initTaskData(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'tasks/findList',
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.tasksList = data.list;
          }
        })
      },
      /**
       * 任务忽略
       */
      ignoreTask(id){
        let this_ = this;
        schoolAxios({
          method: 'put',
          url: 'tasks/edit/'+id,
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.initTaskData();
          }else{
            "操作失败".showMessage();
          }
        })
      },
      /**
       * 点击查看详情数据跳转路由
       */
      saveDataIntoStorage(){
        let this_ = this;
        //保存或修改

        this_.$store.set("clazzId", this_.clazzId);
        this_.$store.set("publishStatus", this_.publishStatus);
        this_.$store.set("classStatus", this_.classStatus);


        //路由跳转
        this_.$router.push({
          name: 'OpenClassMessage',//this_.classStatus==0?'OpenClassMessage':'ClassBasisAfter',
        });
      },
    }
  }
</script>

<style scoped>
  @import "../assets/css/task.css";
  @import "../assets/css/publicStyle.css";
  @import '../assets/css/plugins.css';
</style>



// WEBPACK FOOTER //
// src/components/task.vue